import React from "react";
import { Nav, NavDropdown } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { getCarwashToken } from "../carwashApi";
import { useSecretFeaturesFlag } from "../hooks/useSecretFeatures";
import { useGoogleSheetsAuthContext } from "../hooks/useGoogleSheetAuthContext";

export const NavigationComponent = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const secretFeatures = useSecretFeaturesFlag();

  const { accessToken, requestToken } = useGoogleSheetsAuthContext();

  React.useEffect(() => {
    if (!getCarwashToken()) {
      return navigate("/login");
    }
    navigate(pathname);
  }, [pathname, getCarwashToken]);

  return (
    <Nav
      className="flex-column"
      variant="pills"
      style={{
        backgroundColor: "honeydew",
        height: "100vh",
        overflowY: "scroll",
      }}
      activeKey={pathname}
      onSelect={(eventKey) => {
        if (eventKey) navigate(eventKey);
      }}
    >
      <p>0.0.3.3</p>
      <Nav.Item>
        <Nav.Link eventKey={"/home"}>Home</Nav.Link>
        <Nav.Link eventKey={"/membership"}>Membership</Nav.Link>
        <a className="nav-link" href="/coupon/index.html">
          Coupon
        </a>
        <Nav.Link eventKey={"/transaction"}>Transactions</Nav.Link>
        {secretFeatures ? (
          <Nav.Link
            eventKey={"/daily-tracker-member-usage"}
            onClick={(e) => {
              if (!accessToken) {
                e.preventDefault(); // stop navigation
                requestToken("consent"); // trigger Google OAuth
              }
            }}
          >
            Daily Tracker Member Usage
          </Nav.Link>
        ) : (
          <></>
        )}
        <Nav.Link eventKey={"/login"}>Login</Nav.Link>
      </Nav.Item>
    </Nav>
  );
};
